import React from 'react';
import { motion } from 'framer-motion';
import './FounderBio.css';

const FounderBio: React.FC = () => {
  return (
    <section className="founder-bio">
      <div className="founder-split">
        {/* Sol Taraf - Fotoğraf */}
        <motion.div 
          className="founder-left"
          initial={{ opacity: 0, scale: 1.1 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <img 
            src="/mert-usta-bio.jpeg" 
            alt="Mert Usta - Founder & CEO" 
            className="founder-image"
          />
        </motion.div>

        {/* Sağ Taraf - İçerik */}
        <div className="founder-right">
          <div className="founder-separator"></div>
          
          <motion.div 
            className="founder-info"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <div className="founder-header">
              <h2>Mert Usta</h2>
              <span className="founder-role">Founder & CEO</span>
            </div>
            
            <div className="founder-bio-text">
              <p>
                Mert Usta Almanya'da doğup büyümüş; eğitim hayatını ve şirket yönetimi 
                ile finans alanındaki sağlam altyapısını burada başarıyla tamamlamıştır.
              </p>
              
              <p>
                Litvanya'da bir süre finans danışmanı olarak çalıştıktan sonra, şirketlerin 
                daha hızlı ve daha sağlıklı büyümesine yardımcı olan stratejik bir finans 
                ve yapılandırma yaklaşımı geliştirmiştir.
              </p>

              <p>
                Bugün Türkiye'de güçlü bir ekiple çalışmaktadır: yazılımcılar, tasarımcılar, 
                satış ekibi, avukatlar ve mali müşavirler sayesinde firmalar kısa sürede 
                profesyonel şekilde kurulup ölçeklenebilir hale getirilmektedir.
              </p>

              <p className="founder-highlight">
                Mert Usta; strateji, hız ve ölçülebilir sonuç odaklı çalışan, yönü net genç bir girişimcidir.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default FounderBio;
